//
import BankModel from '@/models/General/GBank'
import PaymentCheckTypeModel from '@/models/POS/PosPaymentCheckType'
import SalePaymentTypeModel from '@/models/POS/PosSalePaymentType'

//
export default [
	{
		name: 'pos_payment_type',
		type: 'autocomplete-model',
		props: {
			itemText: 'type',
			itemValue: 'id',
			label: 'Medio de pago',
			model: SalePaymentTypeModel,
			noAsyncSearch: true,
			paramFilter: {
				type: ['efectivo','cheque', 'transferencia']
			},
			paramSearch: 'type',
		},
		trigger(ctx) {
			if (ctx.value.pos_payment_type.id == 1) {
				ctx.getField('g_bank').props['readonly'] = true
				ctx.getField('account_number').props['readonly'] = true
				ctx.getField('plaza').props['readonly'] = true
				ctx.getField('pos_payment_check_type').props['readonly'] = true
				ctx.getField('charge_date').props['readonly'] = true
				ctx.getField('serial_number').props['readonly'] = true
				ctx.value['g_bank'] = ''
				ctx.value['account_number'] = ''
				ctx.value['plaza'] = ''
				ctx.value['pos_payment_check_type'] = ''
				ctx.value['charge_date'] = ''
				ctx.value['serial_number'] = ''
				console.log('type: efectivo')
			}
			if (ctx.value.pos_payment_type.id == 6) {
				ctx.getField('g_bank').props['readonly'] = false
				ctx.getField('account_number').props['readonly'] = false
				ctx.getField('plaza').props['readonly'] = true
				ctx.getField('pos_payment_check_type').props['readonly'] = true
				ctx.getField('charge_date').props['readonly'] = true
				ctx.getField('serial_number').props['readonly'] = true
				ctx.value['g_bank'] = ''
				ctx.value['account_number'] = ''
				ctx.value['plaza'] = ''
				ctx.value['pos_payment_check_type'] = ''
				ctx.value['charge_date'] = ''
				ctx.value['serial_number'] = ''
				console.log('type: transferencia')
			} 
			if (ctx.value.pos_payment_type.id == 4) {
				ctx.getField('g_bank').props['readonly'] = false
				ctx.getField('account_number').props['readonly'] = false
				ctx.getField('plaza').props['readonly'] = false
				ctx.getField('pos_payment_check_type').props['readonly'] = false
				ctx.getField('charge_date').props['readonly'] = false
				ctx.getField('serial_number').props['readonly'] = false		
				console.log('type: cheque')		
			}
		},
	},
	{
		name: 'amount',
		type: 'currency-field',
		props: {
			label: 'Monto',
		},
	},
	{
		name: 'g_bank',
		type: 'autocomplete-model',
		props: {
			itemText: 'bank',
			itemValue: 'id',
			label: 'Banco',
			model: BankModel,
			paramSearch: 'bank',
		},
	},
	{
		name: 'account_number',
		type: 'float-field',
		props: {
			label: 'Numero de cuenta',
		},
	},
	{
		name: 'plaza',
		type: 'float-field',
		props: {
			label: 'Plaza',
		},
	},
	{
		name: 'pos_payment_check_type',
		type: 'select',
		props: {
			items: [
				{
					text: 'A fecha',
					value: 1,
				},
				{
					text: 'Al dia',
					value: 2,
				}
			],
			label: 'Tipo de cheque',
			returnObject: true,
		},
	},
	{
		name: 'charge_date',
		type: 'date-field',
		props: {
			label: 'Fecha de cargo',
		},
	},
	{
		name: 'serial_number',
		type: 'float-field',
		props: {
			label: 'Numero de serie',
		},
	},
]